import React, { useState, useEffect } from 'react';
import {
  Container,
  Paper,
  Typography,
  TextField,
  Button,
  Box,
  FormControl,
  InputLabel,
  OutlinedInput,
  InputAdornment,
  IconButton
} from '@mui/material';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';

const AddBranchForm = ({ branchData, onSubmit }) => {
  const [confirmPassword, setConfirmPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);
  const [branch, setBranch] = useState({
    branch_id: '',
    branch_name: '',
    branch_address: '',
    name: '',
    email: '',
    contact: '',
    password: '',
    user_type: 'ad',
  });

  useEffect(() => {
    if (branchData) {
      setBranch(branchData);
    } else {
      clearForm();
    }
  }, [branchData]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setBranch({ ...branch, [name]: value });
  };

  const clearForm = () => {
    setBranch({
      branch_id: '',
      branch_name: '',
      branch_address: '',
      name: '',
      email: '',
      contact: '',
      password: '',
      user_type: 'ad',
    });
    setConfirmPassword('');
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!branchData && branch.password !== confirmPassword) {
      alert('Passwords do not match');
      return;
    }

    onSubmit(branch);
    clearForm();
  };

  const togglePassword = () => setShowPassword((prev) => !prev);
  const toggleConfirm = () => setShowConfirm((prev) => !prev);

  return (
      <Container maxWidth="lg" sx={{ mt: 4 }}>
            <Paper elevation={3} sx={{ p: 4, borderRadius: 3 }}>
        <Typography variant="h5" align="center" gutterBottom color="green">
          {branchData ? 'Edit Branch' : 'Add Branch'}
        </Typography>

        <Box component="form" onSubmit={handleSubmit}>

          <TextField
            fullWidth
            label="Branch Id"
            name="branch_id"
            value={branch.branch_id}
            onChange={handleInputChange}
            margin="normal"
            required
          />

          <TextField
            fullWidth
            label="Branch Name"
            name="branch_name"
            value={branch.branch_name}
            onChange={handleInputChange}
            margin="normal"
            required
          />

          <TextField
            fullWidth
            label="Branch Address"
            name="branch_address"
            value={branch.branch_address}
            onChange={handleInputChange}
            margin="normal"
            required
          />

          <TextField
            fullWidth
            label="Admin Name"
            name="name"
            value={branch.name}
            onChange={handleInputChange}
            margin="normal"
            required
          />

          <TextField
            fullWidth
            label="Email Id"
            name="email"
            value={branch.email}
            onChange={handleInputChange}
            margin="normal"
            required
          />

          <TextField
            fullWidth
            label="Mobile No"
            name="contact"
            value={branch.contact}
            onChange={handleInputChange}
            margin="normal"
            required
          />

          {/* Show Password Fields only when adding a new branch */}
          {!branchData && (
            <>
              <FormControl fullWidth margin="normal" required>
                <InputLabel>Password</InputLabel>
                <OutlinedInput
                  name="password"
                  type={showPassword ? 'text' : 'password'}
                  value={branch.password}
                  onChange={handleInputChange}
                  endAdornment={
                    <InputAdornment position="end">
                      <IconButton onClick={togglePassword} edge="end">
                        {showPassword ? <VisibilityOff /> : <Visibility />}
                      </IconButton>
                    </InputAdornment>
                  }
                  label="Password"
                />
              </FormControl>

              <FormControl fullWidth margin="normal" required>
                <InputLabel>Confirm Password</InputLabel>
                <OutlinedInput
                  type={showConfirm ? 'text' : 'password'}
                  value={confirmPassword}
                  onChange={(e) => setConfirmPassword(e.target.value)}
                  endAdornment={
                    <InputAdornment position="end">
                      <IconButton onClick={toggleConfirm} edge="end">
                        {showConfirm ? <VisibilityOff /> : <Visibility />}
                      </IconButton>
                    </InputAdornment>
                  }
                  label="Confirm Password"
                />
              </FormControl>
            </>
          )}

          <Button
            type="submit"
            variant="contained"
            color="success"
            fullWidth
            sx={{ mt: 3, py: 1.5, fontWeight: 'bold' }}
          >
            {branchData ? 'Update Branch' : 'Add Branch'}
          </Button>
        </Box>
      </Paper>
    </Container>
  );
};

export default AddBranchForm;
